import { Title, TitleContainer, TitleDescription } from './styledComponents';

interface ProductSectionHeaderComponentProps {
  title: string;
  titleDescription?: string;
}

const ProductSectionHeaderComponent: React.FC<
  ProductSectionHeaderComponentProps
> = ({ title, titleDescription }) => {
  return (
    <TitleContainer>
      <Title>{title}</Title>
      {titleDescription && (
        <TitleDescription>{titleDescription}</TitleDescription>
      )}
    </TitleContainer>
  );
};

export default ProductSectionHeaderComponent;
